import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { inventaireApi } from "./inventaireApi";
import { IconChevronLeft, IconPlus } from "./icons";
import { badgeInventaire, formatDate, perimetreCourt } from "./statuts";
import "./inventaire.css";

export default function InventairesListPage() {
  const [inventaires, setInventaires] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    const res = await inventaireApi.getAll();
    setInventaires(res.data);
  };

  const handleNavigation = (inv) => {
    if (inv.statut === "VALIDE") {
      navigate(`/inventaires/${inv.id}`); // page lecture
    } else {
      navigate(`/inventaire/${inv.id}`); // page scan continuation
    }
  };

  return (
    <div>
      <div className="page-header">
        <button className="btn-back" onClick={() => navigate("/")}>
          <IconChevronLeft />
          Retour
        </button>
        <div className="page-header-title">Inventaires</div>
      </div>

      <div className="inv-body">
        <button
          className="btn btn-gold"
          style={{ marginBottom: 18 }}
          onClick={() => navigate("/inventaire")}
        >
          <IconPlus />
          Nouvel Inventaire
        </button>

        <div className="inv-list">
          {inventaires.map((inv) => {
            const badge = badgeInventaire(inv.statut);

            return (
              <div key={inv.id} className="inv-card">
                <div className="inv-card-head">
                  <h3>{inv.code || `INV-${inv.id}`}</h3>
                  <span className={`pill pill--${badge.variant}`}>{badge.label}</span>
                </div>

                <div className="inv-info-grid">
                  {/* Périmètre en premier : c'est ce qui permet à l'opérateur de choisir le
                      bon inventaire dans la liste. */}
                  <div>
                    <span>Périmètre</span>
                    <b>{perimetreCourt(inv)}</b>
                  </div>

                  {/* Avancement : valeurs calculées par le serveur. Un inventaire ouvert avant
                      l'introduction du périmètre figé n'en a pas. */}
                  <div>
                    <span>Avancement</span>
                    <b>
                      {inv.totalRouleaux
                        ? `${inv.scannedRouleaux ?? 0} / ${inv.totalRouleaux}`
                        : "-"}
                    </b>
                  </div>

                  <div>
                    <span>Créé par</span>
                    <b>{inv.createdBy}</b>
                  </div>

                  <div>
                    <span>Validé par</span>
                    <b>{inv.validatedBy || "-"}</b>
                  </div>

                  <div>
                    <span>Début</span>
                    <b>{formatDate(inv.startedAt)}</b>
                  </div>

                  <div>
                    <span>Validation</span>
                    <b>{formatDate(inv.validatedAt)}</b>
                  </div>
                </div>

                <button
                  className="btn btn-outline-blue inv-card-btn"
                  onClick={() => handleNavigation(inv)}
                >
                  {inv.statut === "VALIDE" ? "Voir Détails" : "Continuer"}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
